const globalConstants = {
  apiVersion: "v0/",
};

export default globalConstants;
